import { useMediaQuery } from '@mui/material';
import cn from 'classnames';
import CustomTooltip from 'components/CashbackBadge/CustomTooltip/CustomTooltip';
import Button from 'components/form/Button';
import { useTranslation } from 'react-i18next';
import type { Branding } from 'services/model';
import { useThemeContext } from 'services/theme';
import { useAuth } from 'utils/hooks/useAuth';

import { ReactComponent as IconArrowLeft } from 'assets/images/ui/icon-arrow-left.svg';
import { ReactComponent as IconCat } from 'assets/images/ui/icon-cat.svg';

import styles from './Header.module.scss';

interface IHeaderProps {
  brandingData?: Branding;
  className?: string;
  isShowP2P?: boolean;
  noPadding?: boolean;
  url_return?: string;
  withoutAuthBtn?: boolean;
}

const Header = ({ url_return, noPadding = false, brandingData, className, withoutAuthBtn = false }: IHeaderProps) => {
  const { t, i18n } = useTranslation();
  const isTablet = useMediaQuery('(min-width:768px)');
  const { theme } = useThemeContext();

  const { isAuth, isSuccess } = useAuth();

  const getPayformLogo = () => {
    if (brandingData && brandingData.is_enabled) {
      if (brandingData.icon_default) return <img alt='logo' src={brandingData.icon_default} />;

      if (brandingData.icon_dark && brandingData.icon_light) {
        const iconLink = theme === 'light' ? brandingData.icon_light : brandingData.icon_dark;

        return <img alt='logo' src={iconLink} />;
      }
    }

    return <IconCat />;
  };

  const getPayformName = () => {
    if (brandingData && brandingData.is_enabled && brandingData.name) return brandingData.name;

    return 'cryptomus';
  };

  return (
    <div
      className={cn(styles.header, className, {
        [styles.noPadding]: noPadding,
      })}
    >
      {isTablet && url_return && (
        <CustomTooltip
          arrow
          data-debug
          data-testid='my-tooltip'
          direction={i18n.dir()}
          placement='top-start'
          title={<p>{t('Back to the store')}</p>}
          triangleMobilePosition={-16}
          trianglePosition={-1}
        >
          <a className={styles.button__back} href={url_return}>
            <IconArrowLeft />
          </a>
        </CustomTooltip>
      )}

      <div className={styles.header__top}>
        <div className={styles.top__logo}>
          {getPayformLogo()}
          <span>{getPayformName()}</span>
        </div>
        {isSuccess && !isAuth && !withoutAuthBtn ? (
          <a className={styles.sign_up_btn} href='https://app.cryptomus.com/signup' rel='noreferrer' target='_blank'>
            <Button appearance='primary' size='small'>
              {t('Sign up')}
            </Button>
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default Header;
